<contacts-menu (onReload)="onReload()" (outputDownload)="downloadContactsFiltered()"></contacts-menu>
<contact-filter [chipSeparatorKeyCodes]="separatorKeysCodes" (outputFilter)="getFilteredContactsByTenant()"></contact-filter>
<contact-list [list]="list" [showLocalFilter]="showLocalFilter" [chipSeparatorKeyCodes]="separatorKeysCodes"></contact-list>
